import recordsInstance, {
  getRecordInstance,
} from "../ethereum/record-instance";
import { web3 } from "../web3";

export const createRecord = async ({
  name,
  age,
  gender,
  bloodGroup,
  address,
  illnessDetails,
  medicalRecords,
}) => {
  const accounts = await web3.eth.getAccounts();

  return await recordsInstance.methods
    .createRecord(
      name,
      age,
      gender,
      bloodGroup,
      address,
      illnessDetails,
      medicalRecords,
    )
    .send({ from: accounts[0] });
};

export const getRecords = async () => {
  const accounts = await web3.eth.getAccounts();
  return recordsInstance.methods.getRecords().call({ from: accounts[0] });
};

export const getRecord = async (address) => {
  const recordInstance = await getRecordInstance(address);

  return await recordInstance.methods.getUser().call();
};
